var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("text",{"fill":"#fff","fontFamily":"ProximaNova-Regular, Proxima Nova","fontSize":"36"},React.createElement("tspan",{"x":"0","y":"21"},"+")));
}

Add.defaultProps = {"height":"18","viewBox":"0 0 18 18","width":"18"};

module.exports = Add;

Add.default = Add;
